import { render, staticRenderFns } from "./Rubrica.vue?vue&type=template&id=1f91cd80&scoped=true&"
import script from "./Rubrica.vue?vue&type=script&lang=js&"
export * from "./Rubrica.vue?vue&type=script&lang=js&"
import style0 from "./Rubrica.vue?vue&type=style&index=0&id=1f91cd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f91cd80",
  null
  
)

export default component.exports